// extracted by mini-css-extract-plugin
module.exports = {"site":"RateRecycleMethodChart_site__313QY"};